import { cssIf, cssMixin } from "../styledMixins";

const getPaddedAmount = ({ padding: paddingAmount }) => paddingAmount || "20px";
const getMarginAmount = ({ margin: marginAmount }) => marginAmount || "20px";

export const padding = cssMixin`
  padding-left: ${getPaddedAmount};
  padding-right: ${getPaddedAmount};
`;

export const margin = cssMixin`
  margin-left: ${getMarginAmount};
  margin-right: ${getMarginAmount};
`;

export const optionalPadding = cssIf(({padded}) => padded)`${padding()}`
export const optionalMargin = cssIf(({margin: hasMargin}) => hasMargin)`${margin()}`